import React from 'react';
import { observer } from 'mobx-react-lite';
import { SectionTab } from 'polotno/side-panel';
import { Button } from '@blueprintjs/core';

export const TextPanel = observer(({ store }) => {
  return (
    <div style={{ height: '100%', overflow: 'auto', paddingRight: '3px' }}>
      <Button
        fill
        onClick={() =>
          store.activePage.addElement({
            type: 'text',
            fontFamily: 'Gotham A',
            fontSize: 22,
            text: 'Text content',
          })
        }
      >
        Add text
      </Button>
      {/* <Button
        fill
        onClick={() =>
          store.activePage.addElement({
            type: 'text',
            fontFamily: 'Gotham A',
            fontSize: 14,
            text: 'body',
          })
        }
        style={{ marginTop: '20px' }}
      >
        Add body
      </Button> */}
    </div>
  );
});

export const TextSection = {
  name: 'text',
  Tab: (props) => (
    <SectionTab name="Text" {...props}>
      <img
        src={process.env.PUBLIC_URL + '/icons/text.svg'}
        alt="Text"
        style={{ width: '25px' }}
      />
    </SectionTab>
  ),
  Panel: TextPanel,
};
